import { BASE_URL } from "../config";
import gsap from "gsap";
class landingView {
  init() {
    this.section = document.querySelector(".landing");
    this.arrow = this.section.querySelector(".landing__arrow-img");
    this.video = document.querySelector("#bgVideo1");
    this.landingbottom = document.querySelectorAll(
      ".landing__bottom_container",
    );
    // this.addvideo();
    this.landingarrowisclick = false;
  }

  addvideo(url) {
    this.video.src = url;
    this.video.classList.add("active");
    this.video.play().catch(() => {});
  }

  clickHandler(handler) {
    document.querySelector(".landing__arrow").addEventListener("click", () => {
      if (this.landingarrowisclick) return;
      this.landingarrowisclick = true;
      handler();
    });
  }

  landingbottomclickhandler(handler) {
    this.landingbottom.forEach((el) => {
      el.addEventListener("click", () => {
        const id = el.dataset.id;
        handler(id);
      });
    });
  }

  brandLogoHandler(handler) {
    document
      .querySelector(".common__logo")
      .addEventListener("click", () => handler());
  }

  // show() {
  //   document.querySelector(".landing").classList.add("active");
  // }
  // hide() {
  //   document.querySelector(".landing").classList.remove("active");
  // }

  hide(onComplete) {
    // fade out + move up animation
    gsap.to(this.section, {
      opacity: 0,
      y: -100,
      duration: 0.8,
      ease: "power2.inOut",
      onComplete: () => {
        gsap.set(this.section, { display: "none" });
        if (onComplete) onComplete(); // callback to show next
      },
    });
  }

  show() {
    this.landingarrowisclick = false;
    gsap.set(this.section, { display: "flex", opacity: 0, y: 100 });
    gsap.to(this.section, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power2.out",
    });
  }
}

export default new landingView();
